module.exports = __webpack_public_path__ + "img/team_create_icon5.923ba6ac.png";